import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Spinner, Table } from "reactstrap";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Container from "../../../components/Container";
import AppLayout from "../../../components/layouts/AppLayout";
import API from "../../../utils/API";
import Create from "./Create";
import Delete from "./Delete";
import Edit from "./Edit";

const Index = () => {
  const [blocks, setBlocks] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchBlocks = async () => {
    try {
      const data = (await API.get("/api/blocks")).data.data;
      setBlocks(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, [refresh]);

  return (
    <AppLayout>
      <Breadcrumbs
        title="Blocks"
        links={[
          {
            title: "Dashboard",
            link: null,
          },
          {
            title: "Blocks",
            link: null,
          },
        ]}
      />
      <Container>
        <Card className="border-0 shadow mt-5" style={{ minHeight: "70vh" }}>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h1 className="mb-0">All Blocks</h1>
              <Create blocks={blocks} fetchBlocks={fetchBlocks} />
            </div>
            <Table hover responsive>
              <thead>
                <tr className="bg-shade-blue">
                  <th>#</th>
                  <th>Name</th>
                  <th>Campus</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {blocks.length > 0 ? (
                  blocks.map((block, index) => (
                    <tr
                      key={`block-${block.id}`}
                      style={{ verticalAlign: "middle" }}>
                      <th scope="row">{index + 1}</th>
                      <td>{block.name}</td>
                      <td>{block.relationships.campus.name}</td>
                      <td>{moment(block.created_at).format("DD/MM/YY")}</td>
                      <td>{moment(block.updated_at).format("DD/MM/YY")}</td>
                      <td>
                        <Edit block={block} fetchBlocks={fetchBlocks} />
                        <Delete
                          blocks={block}
                          refresh={refresh}
                          setRefresh={setRefresh}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">
                      {loading ? (
                        <Spinner style={{ width: "30px", height: "30px" }} />
                      ) : (
                        "No Blocks Exists"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
    </AppLayout>
  );
};

export default Index;
